import React from 'react';
import { AutoCompleteField } from './index';

const TableCellAutocomplete = ({
    id,
    value,
    label = '',
    options,
    className,
    disabled = false,
    rowIndex,
    placeholder = 'Select',
    error = '',
    containerClass = {},
    errorClassName = '',
    onChange: onChangeProp,
    menuPlacement,
    creatable = false,
}) => {
    const handleChange = option => {
        // Handle both selected options and newly created options
        const optionValue = option?.value || option?.label || option;
        onChangeProp(optionValue, id, rowIndex);
    };

    return (
        <td className={className}>
            <AutoCompleteField
                controlled
                searchable
                creatable={creatable}
                label={label}
                value={value}
                disabled={disabled}
                isMulti={false}
                options={options(rowIndex)}
                placeholder={placeholder}
                containerClass={containerClass}
                errorClassName={errorClassName}
                error={error}
                onChange={handleChange}
                menuPlacement={menuPlacement}
            />
        </td>
    );
};

TableCellAutocomplete.propTypes = {
    ...AutoCompleteField.propTypes,
};

export default TableCellAutocomplete;
